import React from 'react';
import {Box, Stack, Typography} from '@mui/material';

import {StyledListItem} from './styles';
import {QualificationProps} from './types';

export function QualificationItem({qualification}: QualificationProps) {
	if (!qualification.image || !qualification.label) {
		return null;
	}

	return (
		<StyledListItem>
			<Stack direction="row" spacing={1.5}>
				<Box
					component="img"
					sx={{
						height: qualification?.height ?? 16,
						width: qualification?.width ?? 16,
					}}
					src={qualification.image}
					alt={qualification.label}
				/>
				<Typography
					fontSize="0.875rem"
					fontWeight={400}
					lineHeight={1.4}
					color="text.secondary">
					{qualification.label}
				</Typography>
			</Stack>
		</StyledListItem>
	);
}
